// extracted by mini-css-extract-plugin
export var highlightFade = "_2w-4";
export var highlighted = "_2w-3";
export var table = "_2w-1";
export var tableContainer = "_2w-0";
export var totalsRow = "_2w-2";